import { useEffect } from 'react'

import { FeatureFlagsStore } from 'stores'

export const CookiesWidgetHandler = () => {
  const isZaiChatEnabled = FeatureFlagsStore.isFeatureFlagEnabled('isZaiChatEnabled')

  useEffect(() => {
    if (!isZaiChatEnabled) return
    import('./cookies-widget-handler.styles.scss')
  }, [isZaiChatEnabled])

  return null
}
